import React from 'react';

// SUBPAGES
import AnalyticsDashboard from 'pages/administration/dashboard/analyticsDashboard';
import ListUsers from 'pages/administration/users/listUsers';
import HistoryAnnouncements from 'pages/administration/announcements/historyAnnouncements';
import ManagementAnnouncements from 'pages/administration/announcements/managementAnnouncements';
import Statistics from 'pages/administration/statistics';
import ManagementTiles from 'pages/administration/tiles/managementTiles';
import TileForm from 'pages/administration/tiles/tileForm';
import ManagementProposals from 'pages/administration/tiles/managementProposals';
import ManagementLayout from 'pages/administration/tiles/managementLayout';
import ManagementEvents from 'pages/administration/events/managementEvents';
import ManagementResources from 'pages/administration/resources/managementResources';
import Logs from 'pages/administration/superAdmin/logs';
import Settings from 'pages/administration/superAdmin/settings';
import SuperAdminRoute from 'components/SuperAdminRoute';

const adminRoutes = [
    { path: 'dashboard/analytics', element: <AnalyticsDashboard /> },
    { path: 'users/list', element: <ListUsers /> },
    { path: 'announcements/history', element: <HistoryAnnouncements /> },
    { path: 'announcements/management', element: <ManagementAnnouncements /> },
    { path: 'statistics', element: <Statistics /> },
    { path: 'tiles/management', element: <ManagementTiles /> },
    { path: 'tiles/management/form', element: <TileForm /> },
    { path: 'tiles/proposals', element: <ManagementProposals /> },
    { path: 'tiles/layout', element: <ManagementLayout /> },
    { path: 'events/management', element: <ManagementEvents /> },
    { path: 'resources/management', element: <ManagementResources /> },
    { path: 'super-admin/logs', element: (
        <SuperAdminRoute>
            <Logs />
        </SuperAdminRoute>
    )},
    { path: 'super-admin/settings', element: <Settings /> },
];

export default adminRoutes;